"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("models/globals");
const lists_1 = require("../models/lists");
// import {langue} from "./parametres";
class Personne extends webix_jet_1.JetView {
    config() {
        return {
            view: "window",
            height: 600,
            width: 500,
            modal: true,
            position: "center",
            head: (0, globals_1._)("Mes informations"),
            body: {
                view: "form", id: "mesInformations",
                elements: [{
                        view: "text", name: "prenom", label: (0, globals_1._)("Prénom"),
                        width: "300", attributes: { maxlength: 18 },
                        editor: "text"
                    }, {
                        view: "text", name: "nom", label: (0, globals_1._)("Nom"),
                        width: "300", attributes: { maxlength: 24 },
                        editor: "text"
                    }, {
                        view: "text", name: "nomCourt", label: (0, globals_1._)("Identifiant"),
                        tooltip: (0, globals_1._)("L'identifiant peut être utilisé à la place</br>du courriel pour se connecter"), width: "240",
                        attributes: { maxlength: 12 }, editor: "text"
                    }, {
                        view: "text", name: "telephone", label: (0, globals_1._)("Téléphone"),
                        width: "240", attributes: { maxlength: 24 },
                        editor: "text"
                    }, {
                        view: "text", name: "mobile", label: (0, globals_1._)("Mobile"),
                        width: "240", attributes: { maxlength: 24 },
                        editor: "text"
                    }, {
                        view: "text", name: "email", type: "email", label: (0, globals_1._)("Courriel"),
                        width: "300", attributes: { maxlength: 40 },
                        editor: "text",
                        invalidMessage: (0, globals_1._)("Cette adresse courriel n'est pas valide")
                    }, {
                        view: "combo", name: "langue", label: (0, globals_1._)("Code langue"),
                        width: "200", labelWidth: 100,
                        // @ts-ignore
                        value: langue, readonly: true,
                        options: lists_1.localesList,
                    }, {
                        view: "textarea", name: "notes", label: "Notes",
                        width: "400", height: "100",
                        editor: "textarea"
                    }, { cols: [
                            { view: "button", label: (0, globals_1._)("Annuler"), id: "personneAnnulerButton",
                                click: () => this.annuler()
                            }, {
                                view: "button", label: (0, globals_1._)("Enregistrer"), id: "personneEnregistrerButton",
                                click: () => this.enregistrer()
                            }
                        ]
                    }, {
                        template: "", fillspace: true, height: 1
                    }],
                rules: {
                    "email": webix.rules.isEmail
                }
            }
        };
    }
    annuler() {
        // @ts-ignore
        this.getRoot().close();
    }
    enregistrer() {
        if (this.currentForm.validate()) {
            let me = this;
            let values = this.currentForm.getValues();
            // @ts-ignore
            let promise = webix.ajax().post(globals_1.phpPath + "utilisateurs.php?option=updatemydata", values);
            promise.then(function (result) {
                if (result.json().success == false) {
                    webix.alert(result.json().message);
                    return;
                }
                webix.message("Données enregistrées");
                const w = me.getRoot();
                w.close();
            });
            promise.catch(function () {
                webix.alert((0, globals_1._)("Erreur d'enregistrement des données personnelles"));
                const w = me.getRoot();
                w.close();
            });
        }
    }
    showWindow() {
        const w = this.getRoot();
        w.show();
    }
    init() {
        this.currentForm = $$("mesInformations");
        this.currentForm.load(globals_1.phpPath + "utilisateurs.php?option=mydata");
    }
}
exports.default = Personne;
